import jwtDecode from 'jwt-decode';

const TOKEN_KEY = 'authToken';

export function getTokenFromLocalStorage() {
  return localStorage.getItem(TOKEN_KEY);
}

export function saveTokenLocalStorage(token) {
  return localStorage.setItem(TOKEN_KEY, token);
}

export function removeTokenFromLocalStorage() {
  localStorage.setItem(TOKEN_KEY, null);
}

export function isValidToken() {
  const token = getTokenFromLocalStorage();
  if (!token) {
    return false;
  }
  const { exp } = jwtDecode(token);
  const now = new Date();
  return !((exp * 1000) < now.getTime());
}
